import React from 'react'
import { createRoot } from 'react-dom/client'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'

import LoadingSpinner from '../../components/v1/LoadingSpinnerV1'
import { resolveClientSideID } from './utils'

/**
 * A React Launch Darkly provider that can be used in all of our
 * packages since the implementation is the same across packages
 *
 * @param { component } app The React App to render
 */
export const LaunchDarklyProvider = context => async app => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: resolveClientSideID(),
    context,
    options: {},
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
  })

  // render a loading spinner if LDProvider doesn't immediately resolve
  const root = createRoot(document.getElementById('root'))
  root.render(!LDProvider ? <LoadingSpinner /> : <LDProvider>{app}</LDProvider>)
}

export default LaunchDarklyProvider
